var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolanaIconRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_1755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.92387 10.6853C3.03249 10.5775 3.18185 10.5146 3.34026 10.5146H17.7059C17.9684 10.5146 18.0996 10.8291 17.9141 11.0132L15.0762 13.8294C14.9676 13.9372 14.8183 14.0001 14.6598 14.0001H0.294249C0.03174 14.0001 -0.0995146 13.6856 0.0860523 13.5015L2.92387 10.6853Z",
    fill: "#D80000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92387 0.170677C3.03702 0.062881 3.18638 0 3.34026 0H17.7059C17.9684 0 18.0996 0.314405 17.9141 0.498556L15.0762 3.31473C14.9676 3.42252 14.8183 3.4854 14.6598 3.4854H0.294249C0.03174 3.4854 -0.0995146 3.171 0.0860523 2.98685L2.92387 0.170677Z",
    fill: "#D80000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0762 5.39431C14.9676 5.28651 14.8183 5.22363 14.6598 5.22363H0.294249C0.03174 5.22363 -0.0995146 5.53804 0.0860523 5.72219L2.92387 8.53836C3.03249 8.64615 3.18185 8.70903 3.34026 8.70903H17.7059C17.9684 8.70903 18.0996 8.39463 17.9141 8.21048L15.0762 5.39431Z",
    fill: "#D80000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_1755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIconRed);
export default __webpack_public_path__ + "static/media/solanaIconRed.6760121f82e02470cb13ed6dfe234223.svg";
export { ForwardRef as ReactComponent };